import { Box, Card } from "@mui/material";

export default function CardSysPdf({ children, ...props }) {
    return (
        <Box {...props}>
            <Card sx={{ backgroundColor: 'white', boxShadow: 'none', borderRadius: "1rem", padding: "16px", paddingTop: "2px", height:"100%",borderColor:"#01A7E1",border: 1,color:"#01A7E1"}} >
                {children}
            </Card>
        </Box>
    )
}